import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAiChatAttachment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 17,
	viewBox: "0 0 19 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.06853 11.0056L12.8497 4.35276C13.472 3.74226 14.4851 3.74226 15.1074 4.35276C15.7297 4.96325 15.7297 5.95726 15.1074 6.56775L5.94886 15.5843C4.70432 16.8052 2.68593 16.8052 1.43341 15.5843C0.188864 14.3633 0.188864 12.3831 1.43341 11.1543L11.0068 1.76208C12.722 0.0793079 15.4983 0.0793079 17.2136 1.76208C18.9288 3.44484 18.9288 6.16858 17.2136 7.85135L10.4324 14.5042",
		stroke: "#7284FA",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAiChatAttachment;
